/** Mark generated API HTML so the in-app iframe uses the compact mobile layout. */
export function prepareHtmlPreview(html: string): string {
  return html.replace(/<html\b([^>]*)>/i, (_match, attrs: string) => {
    if (/\bclass="/i.test(attrs)) return `<html${attrs.replace(/\bclass="/i, 'class="docs-embed ')}>`;
    return `<html${attrs} class="docs-embed">`;
  });
}
